import { OrganizationKeyName } from "../../../model/Organization";

export const GET_USER_TERM_VERSION = "GET_USER_TERM_VERSION";
export type GetUserTermVersionAction = {
  type: typeof GET_USER_TERM_VERSION;
  organization: OrganizationKeyName;
  userTermId: string;
  userTermVersionId: string;
};
export const getUserTermVersionAction = (
  organization: OrganizationKeyName,
  userTermId: string,
  userTermVersionId: string
): GetUserTermVersionAction => ({
  type: GET_USER_TERM_VERSION,
  organization,
  userTermId,
  userTermVersionId,
});

export const GET_USER_TERM_VERSION_FAIL = "GET_USER_TERM_VERSION_FAIL";
export type GetUserTermVersionFailAction = {
  type: typeof GET_USER_TERM_VERSION_FAIL;
  organization: OrganizationKeyName;
  userTermId: string;
  userTermVersionId: string;
};
export const getUserTermVersionFailAction = (
  organization: OrganizationKeyName,
  userTermId: string,
  userTermVersionId: string
): GetUserTermVersionFailAction => ({
  type: GET_USER_TERM_VERSION_FAIL,
  organization,
  userTermId,
  userTermVersionId,
});

export const GET_USER_TERM_VERSION_SUCCESS = "GET_USER_TERM_VERSION_SUCESS";
export type GetUserTermVersionSuccessAction = {
  type: typeof GET_USER_TERM_VERSION_SUCCESS;
  organization: OrganizationKeyName;
  userTermId: string;
  userTermVersionId: string;
  data: any;
};
export const getUserTermVersionSuccessAction = (
  organization: OrganizationKeyName,
  userTermId: string,
  userTermVersionId: string,
  data: any
): GetUserTermVersionSuccessAction => ({
  type: GET_USER_TERM_VERSION_SUCCESS,
  organization,
  userTermId,
  userTermVersionId,
  data,
});
